import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { Directive, ElementRef, Inject, Input, OnInit } from '@angular/core';
import {
  fileDropZoneDisabledStylesSAG,
  fileDropZoneDisabledStylesSHS,
  fileDropZoneStylesSAG,
  fileDropZoneStylesSHS,
} from './file-drop-zone.styles';
import { style } from '../../utils/style.utils';

@Directive({
  selector: 'div[sag-ui-filedrop-zone]',
})
export class FileDropZoneDirective implements OnInit {
  @Input() disabled = false;

  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      fileDropZoneStylesSAG,
      fileDropZoneStylesSHS
    );

    const disabledStyles = componentStylesByTheme(
      this.theme,
      fileDropZoneDisabledStylesSAG,
      fileDropZoneDisabledStylesSHS
    );

    style(this.elementRef, this.disabled ? disabledStyles() : inputStyles());
  }
}
